import { get, writable } from "svelte/store";
import { appManager } from "../AppManagerStore";
export class ModelsManager {
    constructor(settings) {
        this.models = writable([]);
        this.settings = settings;
    }
    async InitializeAsync() {
        const models = await get(appManager).TripsApi.getModels();
        const modelInfos = [];
        models.forEach(m => {
            var _a, _b, _c, _d;
            const localizationKey = (_a = m.properties) === null || _a === void 0 ? void 0 : _a.localization_key;
            if (typeof localizationKey === "undefined")
                return;
            const modelConfig = this.settings.whitelist.find(x => x.id == m.globalId);
            if (typeof modelConfig === "undefined")
                return;
            const image = (_b = modelConfig.image) !== null && _b !== void 0 ? _b : "img/posts/simulating-commutes/screenshot-sla-mechelen.png";
            const isGlobal = !(typeof m.extent !== "undefined" && m.extent != null);
            const tags = (_c = modelConfig.tags) !== null && _c !== void 0 ? _c : [];
            const vehicles = [];
            const type = (_d = m.properties) === null || _d === void 0 ? void 0 : _d.type;
            if (typeof type !== "undefined") {
                tags.push(type);
            }
            m.layers.forEach(l => {
                const vehicle = get(appManager).TripsApi.vehicles[l.vehicleType];
                if (vehicles.indexOf(vehicle.key) !== -1)
                    return;
                vehicles.push(vehicle.key);
            });
            modelInfos.push({
                id: m.globalId,
                image: image,
                isGlobal: isGlobal,
                localizationKey: localizationKey,
                tags: tags,
                type: modelConfig.type,
                vehicles: vehicles
            });
        });
        this.models.set(modelInfos);
    }
    getModelsStore() {
        return this.models;
    }
}
